import { observable, action, makeObservable } from 'mobx';
import actions, { initialGlobalState } from '../actions';

class Global {
    constructor() {
        makeObservable(this);
    }
    @observable
    sides = [
        {
            id: '1660844937962582016',
            side_name: '平台端',
            side_type: 1,
            inner_state: 1,
            side_url: 'admin',
            comments: '平台租户',
            default_state: 1,
            create_time: 1684811265000,
            update_time: null,
            create_by: null,
            update_by: null
        },
        {
            id: '1660845248693399552',
            side_name: '管理端',
            side_type: 2,
            inner_state: 1,
            side_url: 'admin',
            comments: '普通租户',
            default_state: 0,
            create_time: 1684811339000,
            update_time: null,
            create_by: null,
            update_by: null
        },
        {
            id: '1660845460308619264',
            side_name: '运营端',
            side_type: 2,
            inner_state: 1,
            side_url: 'operate',
            comments: '普通租户',
            default_state: 1,
            create_time: 1684811389000,
            update_time: null,
            create_by: null,
            update_by: null
        },
        {
            id: '1660845731663310848',
            side_name: '开发端',
            side_type: 3,
            inner_state: 1,
            side_url: 'admin',
            comments: '开发租户',
            default_state: 1,
            create_time: 1684811454000,
            update_time: null,
            create_by: null,
            update_by: null
        }
    ];
    @action
    setState = (key, value) => {
        this[key] = value;
    };
    @observable
    shareGlobalData = initialGlobalState;

    //监听发生变化时自动触发
    @action
    setShareGlobalData = (v) => {
        this.shareGlobalData = v;
    };
    //修改主应用变量
    setGlobalState = (v) => {
        actions.setGlobalState(v);
    };

    @observable
    theme = 'blue';

    @action
    setTheme = (v) => {
        this.theme = v;
    };

    @observable
    platform = {};

    @action
    setPlatform = (v) => {
        this.platform = v;
    };

    @action
    setPlatformOther = (v) => {
        this.platformOther = v;
    };
    //账号与安全
    @observable
    settingVisible = false;

    @action
    setSettingVisible = (v) => {
        this.settingVisible = v;
    };
}
export default new Global();
